module.exports = __webpack_public_path__ + "static/media/rsz_contabilidad.598642bc.jpg";